import React from 'react';
import FontAwesome from 'react-fontawesome';

import {OverlayTrigger, Popover} from 'react-bootstrap';

class Card extends React.Component {
    render() {
        var icon = "question";
        for (var i=0; i<this.props.genres.length; i++) {
            var genre = this.props.genres[i];
            if (this.props.genre == genre.value) {
                icon = genre.icon;
            }
        } 

        var iconPrivate = <FontAwesome fixedWidth={true} title="This checklist is private." style={{color: "#888888", fontSize: "14px"}} name="lock"/>;
        var iconPublic = <FontAwesome fixedWidth={true} title="This checklist is public." style={{color: "#88aa88", fontSize: "14px"}} name="users"/>;

        var contributorsTooltip = "";
        var creator = "Creator:\n";
        var contributors = "\n\nContributors:\n";
        if (!this.props.hasOwnProperty("contributors") || this.props.contributors == null || this.props.contributors.length === 0) {
            contributorsTooltip = "There are currently no contributors.";
        } else {
            contributorsTooltip = contributorsTooltip + creator;
            contributorsTooltip = contributorsTooltip + (this.props.contributors[0] && this.props.contributors[0].nickname && this.props.contributors[0].nickname.length>0 ? this.props.contributors[0].nickname : this.props.contributors[0].name);

            if (this.props.contributors.length > 1) {
                contributorsTooltip = contributorsTooltip + contributors;
                for (var i=1; i<this.props.contributors.length; i++) {
                    var contributor = this.props.contributors[i].name;
                    if (i<this.props.contributors.length-1) {
                        contributorsTooltip = contributorsTooltip + contributor + "\n";                
                    } else {
                        contributorsTooltip = contributorsTooltip + contributor;                
                    }
                }
            }
        }

        const popoverContributors = (
        <Popover id="popover-positioned-bottom" title="Contributors">
            {contributorsTooltip}            
        </Popover>
        );

        var iconContributors = <FontAwesome id="contributorsIcon" fixedWidth={true} title={contributorsTooltip} style={{color: "#888888", fontSize: "14px", marginRight: "5px"}} name="user"/>;

        var overlayContributors =
        <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={popoverContributors}>
            {iconContributors}
        </OverlayTrigger>;

        var shared;
        if (this.props.shared) {
            shared = <div style={{position: 'absolute', top: "20px", left: "64px", width: "128px", height: "128px"}}>
                <FontAwesome title="This checklist is shared and can't be edited." fixedWidth={true} style={{opacity: 0.85, color: "darkgreen", fontSize: "100px", width: "128px", height: "128px"}} name="external-link-square" />
            </div>
        }

        var visible;
        if (!this.props.visible) {
            visible = <div style={{position: 'absolute', top: "20px", left: "64px", width: "128px", height: "128px"}}>
                <FontAwesome title="This checklist will not display within the mobile app." fixedWidth={true} style={{opacity: 0.85, color: "darkred", fontSize: "100px", width: "128px", height: "128px"}} name="ban" />
            </div>
        }

        var addButton = this.props.addButton;

        var topLeft;
        if (addButton) {
            topLeft = addButton;
        } else {
            topLeft = this.props.privacy==="public"?iconPublic:iconPrivate;
        }

        var card;
        if (this.props.compact) {
            card =
                <div className="cardCompact" style={{display: "flex", alignItems: "center", justifyContent: "space-between", backgroundColor: this.props.disabled?"#eeeeee":"#222d32", color: this.props.disabled?"#888888":"#bcbcbc"}} onClick={this.props.onClick}>
                    <div style={{display: "flex", alignItems: "center"}}>
                        <FontAwesome fixedWidth={true} style={{fontSize: "32px", marginLeft: "5px"}} name={icon} />
                        <div title={this.props.description} style={{marginLeft: "5px", fontSize: "12px", fontWeight: "normal", maxHeight: "60px", overflowY: "auto"}}>
                            {this.props.title}
                        </div>
                    </div>
                    <div style={{display: "flex", alignItems: "center"}}>
                        <div style={{marginLeft: "10px"}}>
                            {topLeft}
                        </div>    
                        <div style={{position: 'absolute', bottom: "0px", left: "0px", margin: "2px"}}>
                            {overlayContributors}
                        </div>
                        <div style={{marginLeft: "5px", marginRight: "10px"}}>
                            {this.props.menuComponent}
                        </div>
                    </div>    
                </div>;
        } else {
            card =
                <div className="card" style={{backgroundColor: this.props.disabled?"#eeeeee":"#222d32", color: this.props.disabled?"#888888":"#bcbcbc"}} onClick={this.props.onClick}>
                    <div style={{position: 'absolute', top: "20px", left: "0px", width: "246px", height: "256px"}}>
                        <FontAwesome fixedWidth={true} style={{fontSize: "100px", width: "246px", height: "256px"}} name={icon} />
                    </div>
                    <div style={{position: 'absolute', top: "0px", right: "0px", margin: "10px"}}>
                        {this.props.menuComponent}
                    </div>
                    <div style={{position: 'absolute', top: "0px", left: "0px", margin: "10px"}}>
                        {topLeft} {overlayContributors}
                    </div>
                    <div style={{position: 'absolute', top: "125px", left: "0px", margin: "10px"}}>
                        <div style={{fontSize: "16px", fontWeight: "bold"}}>
                            {this.props.title}
                        </div>
                        <div style={{height: "80px", overflowY: "auto"}}>
                            {this.props.description}
                        </div>
                        
                    </div>
                    {shared}
                    {visible}
                </div>;
        }

        return (
            <div>
                {card}
            </div>
        );
    }
}

export default Card;